import { __extends, __rest } from "tslib";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cx from 'classnames';
import { values } from 'lodash-es';
import HotspotLayer from '../containers/HotspotLayer';
import styles from './Image.module.css';
import { isGIF } from '../utils/image';
import * as screenLocation from '../constants/screenLocation';
var hiddenImageMap = {};
var Image = /** @class */ (function (_super) {
    __extends(Image, _super);
    function Image(props) {
        var _this = _super.call(this, props) || this;
        _this.setRef = function (node) {
            _this.image = node;
            if (_this.props.withRef) {
                _this.props.withRef(node);
            }
        };
        var src = _this.props.src;
        if (isGIF(src)) {
            Image.createHiddenImage(src);
        }
        _this._timeouts = [];
        return _this;
    }
    Image.createHiddenImage = function (src) {
        if (!hiddenImageMap[src]) {
            var hiddenImage = new window.Image();
            hiddenImage.src = src;
            hiddenImage.className = styles.hiddenImage;
            hiddenImageMap[src] = hiddenImage;
            document.body.appendChild(hiddenImage);
        }
    };
    Image.prototype.componentDidMount = function () {
        this.resetGIFAnimation();
    };
    Image.prototype.componentWillUpdate = function () {
        this.resetGIFAnimation();
    };
    Image.prototype.componentWillUnmount = function () {
        this._timeouts.map(function (timeout) { return clearTimeout(timeout); });
    };
    Image.prototype.render = function () {
        var _a;
        var _b = this.props, type = _b.type, hotspots = _b.hotspots, annotations = _b.annotations, 
        // TODO Image shouldn't know about its container
        getScreenScrollPos = _b.getScreenScrollPos, getOverlayScrollPos = _b.getOverlayScrollPos, 
        // container should just pass a getScrollPos function
        onClick = _b.onClick, screenID = _b.screenID, id = _b.id, style = __rest(_b, ["type", "hotspots", "annotations", "getScreenScrollPos", "getOverlayScrollPos", "onClick", "screenID", "id"]);
        var imageClass = cx(styles.image, (_a = {},
            _a[styles.annotating] = this.props.isAnnotating,
            _a));
        return (React.createElement("div", { className: imageClass, "data-layer-type": this.props['data-layer-type'], id: id, onClick: onClick, ref: this.setRef, style: style },
            React.createElement(HotspotLayer, { annotations: annotations, getOverlayScrollPos: getOverlayScrollPos, getScreenScrollPos: getScreenScrollPos, height: style.height, hotspots: hotspots, location: type, screenID: screenID })));
    };
    Image.prototype.resetGIFAnimation = function () {
        var _this = this;
        if (!this.props.isOverlay) {
            // This component is used for the header, footer, and overlay.
            // The ScreenImage component already handles GIF resetting for
            // the screen so we only need do it here if we're an overlay.
            // Probably better to move this reset stuff to a HOC and only
            // wrap in containers/overlay.
            return;
        }
        var src = this.props.src;
        if (!isGIF(src)) {
            return;
        }
        var hiddenImage = hiddenImageMap[src];
        // setTimeout needed for Safari
        this._timeouts.push(setTimeout(function () {
            hiddenImage.src = _this.props.src;
        }, 0));
        // setTimeout works in Firefox too but *not* in Chrome so we set
        // the src here again *without* the timeout for Chrome
        hiddenImage.src = this.props.src;
        this.image.style.opacity = 0.99;
        this._timeouts.push(setTimeout(function () {
            _this.image.style.opacity = 1;
        }, 0));
    };
    return Image;
}(Component));
Image.propTypes = {
    type: PropTypes.oneOf(values(screenLocation)),
    src: PropTypes.string.isRequired,
    hotspots: PropTypes.array,
    isAnnotating: PropTypes.bool,
    areCommentsDisplayed: PropTypes.bool,
    getScreenScrollPos: PropTypes.func,
    onClick: PropTypes.func,
    scrollTop: PropTypes.number,
    annotations: PropTypes.arrayOf(PropTypes.shape({
        left: PropTypes.number,
        top: PropTypes.number,
    })),
    isOverlay: PropTypes.bool,
    withRef: PropTypes.func,
    getOverlayScrollPos: PropTypes.func,
    screenID: PropTypes.number.isRequired,
    id: PropTypes.oneOf([PropTypes.string, PropTypes.number]).isRequired,
};
export default Image;
